import { useState } from 'react'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap'
import styles from './faq.module.css'

const Faqaccordion = (props) => {
    const [open, setOpen] = useState('1')

    const toggle = (id) => {
        setOpen(open === id ? undefined : id)
    }

    return (
        <div style={{ background: props?.bgcolor || "" }}>
            <div className={`container ${styles.accordion_wrapper}`}>
                <h4>Frequently asked questions</h4>
                {props.questions && props.questions.length > 0 && (
                    <Accordion open={open} toggle={toggle}>
                        {props.questions.map((item) => (
                            <AccordionItem key={item.targetId} className="item">
                                <AccordionHeader
                                    targetId={item.targetId}
                                    className="bg-grey-9 border-0 d-flex justify-content-center align-items-center accordionBtnChange"
                                >
                                    <div className="d-flex justify-content-between w-100 align-items-center">
                                        <h5 className="text-grey-dark-100 fw-500 mb-0 font-size-lg-mds font-size-sm pe-3">
                                            <b>{item.heading}</b>
                                        </h5>
                                        <div className={`${styles.accordionbtn}`}>
                                            {open === item.targetId ? "−" : "+"}
                                        </div>
                                    </div>
                                </AccordionHeader>
                                <AccordionBody accordionId={item.targetId} className={styles.accordion_body}>
                                    <div>
                                        {item.subheading && (
                                            item.subheading.includes('<') ? (
                                                <p dangerouslySetInnerHTML={{ __html: item.subheading }}></p>
                                            ) : (
                                                <p>{item.subheading}</p>
                                            )
                                        )}
                                        {item.bulletpoints && item.bulletpoints.length > 0 && (
                                            <ul className={styles.bullet_points}>
                                                {item.bulletpoints.map((bullet, index) => (
                                                    <li key={index}>{bullet.point}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </AccordionBody>
                            </AccordionItem>
                        ))}
                    </Accordion>
                )}
            </div>
        </div>
    )
}

export default Faqaccordion
